import { axiosInstance as axios } from "services";

export const removeCompanyNote = async ({ companyId, noteId }) => {
  const { data } = await axios.delete(`/admin/subscription/company/${companyId}/notes/${noteId}`);
  if (!data.success) throw new Error(data.error?.message || "Failed to remove note");
  return data;
};

